import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { COLOR_SUCCESS_1 } from 'src/utils/colors';
import { callApi } from 'src/core/callApi';

function Enterprise({ adminPassword }) {
  const [marketMarkerApiUserData, setMarketMakerApiUserData] = useState<any>();
  const [incomeHistoryApiUserData, setIncomeHistoryApiUserData] = useState<any>();
  const [marketMarkerApiUserRows, setMarketMakerApiUserRows] = useState<any>([]);
  const [incomeHistoryApiUserRows, setIncomeHistoryApiUserRows] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showGridLoading, setShowGridLoading] = useState<boolean>(false);
  const [showConfirmResetButtonModal, setShowConfirmResetButtonModal] = useState<boolean>(false);
  const [resetUserdetails, setResetUserDetails] = useState<any>();
  const [apiName, setApiName] = useState<string>('');
  const [companyNameOfB2BTrial, setCompanyNameOfB2BTrial] = useState<string>('');
  const [showAlertForB2BTrial, setShowAlertForB2BTrial] = useState<boolean>(false);
  const [personalEmailIDOfB2BTrailUser, setPersonalEmailIDOfB2BTrailUser] = useState<string>('');
  const [allowedAPICallsForB2BTrialUser, setAllowAPICallsForB2BTrialUser] =useState<string>('');
  const [trialAccountEmail, settrialAccountEmail] = useState<string>('');
  const [JWTToken, setJWTToken] = useState<string>('');
  const [trialKey, settrialKey] = useState<string>('');
  const [showApiLoader, setShowApiLoader] = useState<boolean>(false);

  const marketMakerApiUserTableColumn: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 200, hide: true },
    {
      field: 'email',
      headerName: 'Email',
      width: 280,
      editable: false,
    },
    {
      field: 'company',
      headerName: 'Company',
      width: 150,
      editable: false,
    },
    {
      field: 'access_type',
      headerName: 'Access Type',
      width: 150,
      editable: false,
    },
    {
      field: 'premium_type',
      headerName: 'Premium Type',
      width: 150,
      editable: false,
    },
    {
      field: 'api_calls',
      headerName: 'Api calls made',
      width: 100,
      editable: false,
    },
    {
      field: 'test_calls_left',
      headerName: 'Test Calls left',
      width: 100,
      editable: false,
    },
    {
      field: 'poc',
      headerName: 'POC',
      width: 150,
      editable: false,
    },
    {
      field: 'poc_contact',
      headerName: 'POC Contact',
      width: 250,
      editable: false,
    },
    {
      field: 'reset',
      headerName: 'Reset',
      width: 100,
      renderCell: (params: any) => {
        const rowData = params.row;
        return (
          <Button
            onClick={() => {
              setResetUserDetails(rowData);
              setShowConfirmResetButtonModal(true);
              setApiName('marketMaker');
            }}
          >
            Reset
          </Button>
        );
      },
      sortable: false,
    },
  ];

  const incomeHistoryApiUserTableColumn: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 200, hide: true },
    {
      field: 'email',
      headerName: 'Email',
      width: 280,
      editable: false,
    },
    {
      field: 'company',
      headerName: 'Company',
      width: 150,
      editable: false,
    },
    {
      field: 'access_type',
      headerName: 'Access Type',
      width: 150,
      editable: false,
    },
    {
      field: 'estimator_full',
      headerName: 'estimator_full',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_ltm',
      headerName: 'estimator_ltm',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_summary_monthly',
      headerName: 'estimator_summary_monthly',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_with_comps',
      headerName: 'estimator_with_comps',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_with_comps_ltm',
      headerName: 'estimator_with_comps_ltm',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_with_comps_ltm_quartiles',
      headerName: 'estimator_with_comps_ltm_quartiles',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_with_comps_quartiles',
      headerName: 'estimator_with_comps_quartiles',
      width: 100,
      editable: false,
    },
    {
      field: 'missing_data_response',
      headerName: 'missing_data_response',
      width: 100,
      editable: false,
    },
    {
      field: 'summary_monthly',
      headerName: 'summary_monthly',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_summary',
      headerName: 'estimator_summary',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_summary_monthly_quartiles',
      headerName: 'estimator_summary_monthly_quartiles',
      width: 100,
      editable: false,
    },
    {
      field: 'estimator_summary_quartiles',
      headerName: 'estimator_summary_quartiles',
      width: 100,
      editable: false,
    },
    {
      field: 'poc',
      headerName: 'POC',
      width: 150,
      editable: false,
    },
    {
      field: 'poc_contact',
      headerName: 'POC Contact',
      width: 250,
      editable: false,
    },
    {
      field: 'reset',
      headerName: 'Reset',
      width: 100,
      renderCell: (params: any) => {
        const rowData = params.row;
        return (
          <Button
            onClick={() => {
              setResetUserDetails(rowData);
              setShowConfirmResetButtonModal(true);
              setApiName('incomeHistory');
            }}
          >
            Reset
          </Button>
        );
      },
      sortable: false,
    },
  ];

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    if (marketMarkerApiUserData) {
      let rows = getMarketMakerApiUserRows();
      setMarketMakerApiUserRows(rows);
    }

    if (incomeHistoryApiUserData) {
      let rows = getIncomeHistoryApiUserRows();
      setIncomeHistoryApiUserRows(rows);
    }
  }, [marketMarkerApiUserData, incomeHistoryApiUserData]);

  const fetchUserData = async () => {
    const queryParams = {
      admin_password: encodeURIComponent(adminPassword),
    };
    const marketMakerUrl =
      'https://lexycbhkc6.execute-api.us-east-2.amazonaws.com/default/getMarketMakerApiUserDetails';
    const incomeHistoryUrl =
      'https://qxrdgaqnnh.execute-api.us-east-2.amazonaws.com/default/getIncomeHistoryApiUserDetails';
    const incomeHistoryUrlRes = await callApi(incomeHistoryUrl, { queryParams }, false);
    const marketMakerUrlRes = await callApi(marketMakerUrl, { queryParams }, false);
    setMarketMakerApiUserData(marketMakerUrlRes['userData']);
    setIncomeHistoryApiUserData(incomeHistoryUrlRes['user_data']);
    setIsLoading(false);
    setShowGridLoading(false);
  };

  const getIncomeHistoryApiUserRows = () => {
    let rows: any = [];
    let id = 0;
    for (const data of incomeHistoryApiUserData) {
      const estimator_full_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_full
          ? data['api_response_counter']['estimator_full']
          : '_';
      const estimator_ltm_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_ltm
          ? data['api_response_counter']['estimator_ltm']
          : '_';
      const estimator_summary_monthly_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_summary_monthly
          ? data['api_response_counter']['estimator_summary_monthly']
          : '_';
      const estimator_with_comps_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_with_comps
          ? data['api_response_counter']['estimator_with_comps']
          : '_';
      const estimator_with_comps_ltm_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_with_comps_ltm
          ? data['api_response_counter']['estimator_with_comps_ltm']
          : '_';
      const estimator_with_comps_ltm_quartiles_value =
        data['access_type'] === 'Premium' &&
        data['api_response_counter']?.estimator_with_comps_ltm_quartiles
          ? data['api_response_counter']['estimator_with_comps_ltm_quartiles']
          : '_';
      const estimator_with_comps_quartiles_value =
        data['access_type'] === 'Premium' &&
        data['api_response_counter']?.estimator_with_comps_quartiles
          ? data['api_response_counter']['estimator_with_comps_quartiles']
          : '_';
      const missing_data_response_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.missing_data_response
          ? data['api_response_counter']['missing_data_response']
          : '_';
      const summary_monthly_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.summary_monthly
          ? data['api_response_counter']['summary_monthly']
          : '_';
      const estimator_summary_value =
        data['access_type'] === 'Premium' && data['api_response_counter']?.estimator_summary
          ? data['api_response_counter']['estimator_summary']
          : '_';
      const estimator_summary_monthly_quartiles_value =
        data['access_type'] === 'Premium' &&
        data['api_response_counter']?.estimator_summary_monthly_quartiles
          ? data['api_response_counter']['estimator_summary_monthly_quartiles']
          : '_';
      const estimator_summary_quartiles_value =
        data['access_type'] === 'Premium' &&
        data['api_response_counter']?.estimator_summary_quartiles
          ? data['api_response_counter']['estimator_summary_quartiles']
          : '_';
      rows.push({
        id: id,
        email: data['email'],
        company: data['company_name'],
        access_type: data['access_type'],
        estimator_full: estimator_full_value,
        estimator_ltm: estimator_ltm_value,
        estimator_summary_monthly: estimator_summary_monthly_value,
        estimator_with_comps: estimator_with_comps_value,
        estimator_with_comps_ltm: estimator_with_comps_ltm_value,
        estimator_with_comps_ltm_quartiles: estimator_with_comps_ltm_quartiles_value,
        estimator_with_comps_quartiles: estimator_with_comps_quartiles_value,
        missing_data_response: missing_data_response_value,
        summary_monthly: summary_monthly_value,
        estimator_summary: estimator_summary_value,
        estimator_summary_monthly_quartiles: estimator_summary_monthly_quartiles_value,
        estimator_summary_quartiles: estimator_summary_quartiles_value,
        poc: data['poc'],
        poc_contact: data['poc_contact'],
      });
      id += 1;
    }
    return rows;
  };

  const getMarketMakerApiUserRows = () => {
    let rows: any = [];
    let id = 0;
    for (const data of marketMarkerApiUserData) {
      rows.push({
        id: id,
        email: data['email'],
        company: data['company_name'],
        access_type: data['access_type'],
        premium_type: data['premium_type'],
        api_calls: data['api_calls'],
        test_calls_left: data['test_calls_left'],
        poc: data['poc'],
        poc_contact: data['poc_contact'],
      });
      id += 1;
    }
    return rows;
  };

  const handleReset = async () => {
    setShowGridLoading(true);
    setShowConfirmResetButtonModal(!showConfirmResetButtonModal);
    const email = resetUserdetails.email;
    const queryParams = {
      admin_password: encodeURIComponent(adminPassword),
      email: encodeURIComponent(email),
      api_name: apiName,
    };
    const url =
      'https://hf92ho8lh9.execute-api.us-east-2.amazonaws.com/default/resetB2BUserDynamoDB';
    const res = await callApi(url, { queryParams }, false);
    if (res.result == 'Done') {
      fetchUserData();
    }
  };

  const handleCreateTrialUserButton = async () => {
    if (!companyNameOfB2BTrial || !personalEmailIDOfB2BTrailUser || !allowedAPICallsForB2BTrialUser) {
      setShowAlertForB2BTrial(true);
    } else {
      setShowApiLoader(true);
      const queryParams = {
        admin_password: encodeURIComponent(adminPassword),
        userPersonalEmail: encodeURIComponent(personalEmailIDOfB2BTrailUser),
        companyName: encodeURIComponent(companyNameOfB2BTrial),
        trialApiCallAllowed: allowedAPICallsForB2BTrialUser
      };
      const url =
        'https://6l8kzcc5k6.execute-api.us-east-2.amazonaws.com/default/createB2BIncomeHistoryTrialUser';
      const res = await callApi(url, { queryParams }, false);
      console.log('RES-->', res);
      settrialAccountEmail(res.email);
      setJWTToken(res.jwt_token);
      settrialKey(res.trial_key);
      setShowApiLoader(false);
      fetchUserData();
    }
  };

  const ConfirmResetButtonModal = () => {
    let access_type = resetUserdetails.access_type;
    return (
      <Modal
        open={showConfirmResetButtonModal}
        onClose={() => {
          setShowConfirmResetButtonModal(!showConfirmResetButtonModal);
        }}
      >
        <Box
          sx={{
            width: '30vw',
            height: '20vh',
            background: 'white',
            border: '1px solid white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '30px',
            borderRadius: 4,
          }}
        >
          {access_type == 'Trial' && <Typography variant="h6">Not a Premium User</Typography>}
          {access_type == 'Premium' && (
            <Box>
              <Typography variant="h6">
                Are you sure that you want to{' '}
                <Typography variant="h6" sx={{ color: 'red', display: 'inline' }}>
                  Reset
                </Typography>{' '}
                the dynamoDB for{' '}
                <Typography variant="h6" sx={{ color: 'green', display: 'inline' }}>
                  {resetUserdetails.company}
                </Typography>
                ?
              </Typography>
              <Button
                sx={{
                  width: '100%',
                  backgroundColor: '#E32636',
                  color: 'white',
                  '&:hover': { backgroundColor: '#E32636' },
                }}
                onClick={handleReset}
              >
                Reset
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    );
  };

  return (
    <Box
      sx={{
        height: '95%',
        width: '100%',
        paddingTop: '10px',
        overflowY: 'auto',
      }}
    >
      {showConfirmResetButtonModal && <ConfirmResetButtonModal />}
      {!isLoading && (
        <Box sx={{ height: '100%', width: '100%' }}>
          <Box
            sx={{
              height: '400px',
              width: '100%',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Typography variant="h4" sx={{ color: 'white' }}>
              Market Maker Api User Details
            </Typography>
            <Box sx={{ height: '300px', width: '100%' }}>
              <DataGrid
                loading={showGridLoading}
                sortingOrder={['desc']}
                sx={{ backgroundColor: 'white' }}
                rows={marketMarkerApiUserRows}
                columns={marketMakerApiUserTableColumn}
                disableColumnFilter={true}
                disableColumnMenu={true}
              />
            </Box>
          </Box>
          <Box
            sx={{
              height: '750px',
              width: '100%',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Typography variant="h4" sx={{ color: 'white' }}>
              Income History Api User Details
            </Typography>
            <Box sx={{ height: '700px', width: '100%', overflowX: 'auto' }}>
              <DataGrid
                sortingOrder={['desc']}
                loading={showGridLoading}
                sx={{ backgroundColor: 'white' }}
                rows={incomeHistoryApiUserRows}
                columns={incomeHistoryApiUserTableColumn}
                disableColumnFilter={true}
                disableColumnMenu={true}
              />
            </Box>
          </Box>
          <Box
            sx={{
              height: '700px',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '10px',
            }}
          >
            <Box
              sx={{
                width: '70%',
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                padding: '10px',
              }}
            >
              <Typography variant="h4" sx={{ marginBottom: '10px' }}>
                Create B2B Income History Api Trial Account
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Typography
                  variant="h6"
                  style={{ width: '300px', display: 'flex', alignItems: 'center' }}
                >
                  Company Name:
                </Typography>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={companyNameOfB2BTrial}
                  onChange={e => {
                    setCompanyNameOfB2BTrial(e.target.value);
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Typography
                  variant="h6"
                  style={{ width: '300px', display: 'flex', alignItems: 'center' }}
                >
                  Company Personal Email ID:
                </Typography>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={personalEmailIDOfB2BTrailUser}
                  onChange={e => {
                    setPersonalEmailIDOfB2BTrailUser(e.target.value);
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Typography
                  variant="h6"
                  style={{ width: '300px', display: 'flex', alignItems: 'center' }}
                >
                  API Calls Allowed:
                </Typography>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={allowedAPICallsForB2BTrialUser}
                  onChange={e => {
                    setAllowAPICallsForB2BTrialUser(e.target.value);
                  }}
                />
              </Box>
              <Button
                sx={{
                  width: '40%',
                  backgroundColor: COLOR_SUCCESS_1,
                  color: 'white',
                  '&:hover': { backgroundColor: COLOR_SUCCESS_1 },
                }}
                onClick={handleCreateTrialUserButton}
              >
                {showApiLoader ? <CircularProgress /> : 'Create Trial Account'}
              </Button>
              {showAlertForB2BTrial && (
                <Alert severity="error"> Enter both of the above values</Alert>
              )}
              {trialAccountEmail && (
                <Box sx={{width:'100%'}}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="medium">
                      <TableHead>
                        <TableRow>
                          <TableCell>Key</TableCell>
                          <TableCell align="right">Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow
                          key={trialAccountEmail}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {'Email'}
                          </TableCell>
                          <TableCell align="right">{trialAccountEmail}</TableCell>
                        </TableRow>
                        <TableRow
                          key={'token'}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {'JWT Token'}
                          </TableCell>
                          <TableCell align="right">{JWTToken}</TableCell>
                        </TableRow>
                        <TableRow
                          key={trialKey}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {'Trial Key'}
                          </TableCell>
                          <TableCell align="right">{trialKey}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography variant="body2" sx={{fontWeight:500}}>
                    Mail Has been sent to {personalEmailIDOfB2BTrailUser} with credentials.
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
      {isLoading && (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
}

export default Enterprise;
